<nav class="main-nav" [attr.aria-label]="i18n.t('navigation.landmark')">
  <h3 class="main-nav-heading">{{ i18n.t('navigation.heading') }}</h3>

  <div class="main-nav-section">
    <ul class="main-nav-list">
      @for (item of primaryNavItems(); track item.route) {
        <li>
          <a
            [routerLink]="navigationLocked() ? null : resolveRoute(item.route)"
            role="link"
            [attr.aria-disabled]="navigationLocked() ? 'true' : null"
            [attr.tabindex]="navigationLocked() ? -1 : null"
            class="main-nav-link"
            [class.active]="isActive(item.route)"
            [attr.title]="isTextCollapsed() ? item.label : null"
          >
            <cw-icon [icon]="item.icon" font="material" size="sm"></cw-icon>
            <span>{{ item.label }}</span>
          </a>
        </li>
      }
    </ul>
  </div>

  <div class="main-nav-section main-nav-section--footer">
    <ul class="main-nav-list">
      @for (item of footerNavItems(); track item.route) {
        <li>
          <a
            [routerLink]="navigationLocked() ? null : resolveRoute(item.route)"
            role="link"
            [attr.aria-disabled]="navigationLocked() ? 'true' : null"
            [attr.tabindex]="navigationLocked() ? -1 : null"
            class="main-nav-link"
            [class.active]="isActive(item.route)"
            [attr.title]="isTextCollapsed() ? item.label : null"
          >
            <cw-icon [icon]="item.icon" font="material" size="sm"></cw-icon>
            <span>{{ item.label }}</span>
          </a>
        </li>
      }
    </ul>
  </div>
</nav>
